import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year4/Spring/Fractions/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Fractions',
  field: 'Number',
  weeks: [6, 9],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/Fractions/1UnderstandTheWhole" */ './1UnderstandTheWhole'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(/* webpackChunkName: "Year4/Spring/Fractions/2CountBeyond1" */ './2CountBeyond1')
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/Fractions/3PartitionAMixedNumber" */ './3PartitionAMixedNumber'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/Fractions/4NumberLinesWithMixedNumbers" */ './4NumberLinesWithMixedNumbers'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/Fractions/5CompareAndOrderMixedNumbers" */ './5CompareAndOrderMixedNumbers'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/Fractions/6UnderstandImproperFractions" */ './6UnderstandImproperFractions'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/Fractions/7ConvertMixedNumbersToImproperFractions" */ './7ConvertMixedNumbersToImproperFractions'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/Fractions/8ConvertImproperFractionsToMixedNumbers" */ './8ConvertImproperFractionsToMixedNumbers'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/Fractions/9EquivalentFractionsOnANumberLine" */ './9EquivalentFractionsOnANumberLine'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/Fractions/10EquivalentFractionFamilies" */ './10EquivalentFractionFamilies'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/Fractions/11AddTwoOrMoreFractions" */ './11AddTwoOrMoreFractions'
        )
    }),
    // Step 12
    newSmallStepContent({
      ...BlockModel.smallSteps[11],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/Fractions/12AddFractionsAndMixedNumbers" */ './12AddFractionsAndMixedNumbers'
        )
    }),
    // Step 13
    newSmallStepContent({
      ...BlockModel.smallSteps[12],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/Fractions/13SubtractTwoFractions" */ './13SubtractTwoFractions'
        )
    }),
    // Step 14
    newSmallStepContent({
      ...BlockModel.smallSteps[13],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/Fractions/14SubtractFromWholeAmounts" */ './14SubtractFromWholeAmounts'
        )
    }),
    // Step 15
    newSmallStepContent({
      ...BlockModel.smallSteps[14],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Spring/Fractions/15SubtractFromMixedNumbers" */ './15SubtractFromMixedNumbers'
        )
    })
  ]
});
export default Block;
